<template>
    <div>
      <el-card class="card-container">
      <template #header>
        <div class="card-header">
          <span>Feedback Analytics</span>
        </div>
      </template>
    </el-card>
    </div>
  </template>

<script>
import { xray } from '../../../config/pluginInit'

export default {
  name: 'FeedbackSubmissions',
  mounted () {
    xray.index()
  }
  // Your component options here
}
</script>

  <style scoped>
.card-container {
  margin: 0 20px 20px 20px;
}

.card-header {
  background: transparent;
  border-bottom: none;
}

.card-header span {
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color) !important;
}
</style>
